import { useEffect } from 'react'
import { noop } from 'ramda-adjunct'
import { getIsMobileDevice } from '../deviceUtils'

export function useRefreshSubscription({ onVisible }): void {
  useEffect(
    function refreshMobileSubscription(): () => void {
      if (!getIsMobileDevice()) {
        return noop
      }

      const refetchOnVisibilityChange = (): void => {
        if (document.visibilityState === 'visible') {
          onVisible()
        }
      }

      document.addEventListener('visibilitychange', refetchOnVisibilityChange)

      return (): void => {
        document.removeEventListener(
          'visibilitychange',
          refetchOnVisibilityChange
        )
      }
    },
    [onVisible]
  )
}
